import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { toggleTimeslot } from "./TimeslotInputState";
export function LocationOptionPartsOfDayInput(props) {
    const { availability, selection, updateSelection, date } = props;
    const disableMorning = !availability.morning;
    const disableAfternoon = !availability.afternoon;
    const disableEvening = !availability.evening;
    return /*#__PURE__*/ _jsxs("fieldset", {
        className: "zv-form__set",
        children: [
            /*#__PURE__*/ _jsxs("legend", {
                className: "zv-form__label",
                children: [
                    "Gewenste dagdeel",
                    date ? '' : ' (kies eerst een datum)'
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "form__checkbox",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "checkbox",
                        name: "dayparts",
                        id: "morning",
                        className: "form__input--checkbox",
                        disabled: disableMorning,
                        checked: selection.morning,
                        onChange: (_)=>updateSelection(toggleTimeslot('morning')(selection))
                    }),
                    /*#__PURE__*/ _jsxs("label", {
                        htmlFor: "morning",
                        className: `form__label--checkbox${disableMorning ? ' form__label--disabled' : ''}`,
                        children: [
                            "Ochtend ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "form__extra text--s",
                                children: "(8:00-12:00)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "form__checkbox",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "checkbox",
                        name: "dayparts",
                        id: "afternoon",
                        className: "form__input--checkbox",
                        disabled: disableAfternoon,
                        checked: selection.afternoon,
                        onChange: (_)=>updateSelection(toggleTimeslot('afternoon')(selection))
                    }),
                    /*#__PURE__*/ _jsxs("label", {
                        htmlFor: "afternoon",
                        className: `form__label--checkbox${disableAfternoon ? ' form__label--disabled' : ''}`,
                        children: [
                            "Middag ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "form__extra text--s",
                                children: "(13:00-17:00)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "form__checkbox",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "checkbox",
                        name: "dayparts",
                        id: "evening",
                        className: "form__input--checkbox",
                        disabled: disableEvening,
                        checked: selection.evening,
                        onChange: (_)=>updateSelection(toggleTimeslot('evening')(selection))
                    }),
                    /*#__PURE__*/ _jsxs("label", {
                        htmlFor: "evening",
                        className: `form__label--checkbox${disableEvening ? ' form__label--disabled' : ''}`,
                        children: [
                            "Avond ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "form__extra text--s",
                                children: "(18:00-22:00)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
